/**
 * Passwortbestätigung für Löschvorgänge und Änderungen an Systemrollen.
 *
 * Der Server verlangt dafür das eigene Passwort (Kopfzeile `X-Confirm-Password`),
 * beim Löschen eines Superadmin-Kontos zusätzlich den Code der Authenticator-App
 * (`X-Confirm-Totp`). Die Oberfläche fragt beides hier ab: `PasswordConfirmHost`
 * meldet sich als Fragesteller an, `api.delete` & Co. rufen `askPassword` auf.
 * `null` heißt: abgebrochen.
 */
export type Bestaetigung = { password: string; totp?: string };
type Asker = (hint?: string, mitCode?: boolean) => Promise<Bestaetigung | null>;

let asker: Asker | null = null;

export const registerPasswordAsker = (next: Asker | null) => {
  asker = next;
};

export const askPassword: Asker = (hint, mitCode) => (asker ? asker(hint, mitCode) : Promise.resolve(null));
